module.exports = __webpack_public_path__ + "img/Rectangle 19header.2f520516.png";